export const benefits = [

  {
    image: {
      name: 'Picture of the author',
      url: '/img/benefits/webinar.svg'
    },
    title: 'Control de proveedores',
    description: 'Catálogo ilimitado de proveedores. Asigna precios especiales a cada proveedor por material. Obtén reportes de cuentas por pagar.',
    list1: 'Catálogo ilimitado de proveedores.',
    list2: 'Asigna precios especiales a cada proveedor por material.',
    list3: 'Obtén reportes de cuentas por pagar.'

  },

  {
    image: {
      name: 'Picture of the author',
      url: '/img/benefits/shelf.svg'
    },
    title: 'Control de inventarios',
    description: 'Entérate del total de kilos que tienes en tu patio de un solo vistazo. Tabulador de precios por material. Obtén reporte detallado de entradas y salidas ',
    list1: 'Entérate del total de kilos que tienes en tu patio de un solo vistazo.',
    list2: 'Tabulador de precios por material. ',
    list3: 'Obtén reporte detallado de entradas y salidas.'
  },
  {
    image: {
      name: 'Picture of the author',
      url: '/img/benefits/weight_scale.svg'
    },
    title: 'Config. para básculas',
    description: 'Compatible con la mayoría de básculas con conexión a computadoras (RS-232). Lee el peso directamente de tu báscula a la computadora. Elimina el error de captura por factor humano.',
    list1: 'Compatible con la mayoría de básculas con conexión a computadoras (RS-232). ',
    list2: 'Lee el peso directamente de tu báscula a la computadora.',
    list3: 'Elimina el error de captura por factor humano.'
  },
  {
    image: {
      name: 'Picture of the author',
      url: '/img/benefits/log_in.svg'
    },
    title: 'Control de clientes ',
    description: 'Catálogo ilimitado de clientes. Asigna límite de crédito por cliente. Obtén reportes de cuentas por cobrar.',
    list1: 'Catálogo ilimitado de clientes.',
    list2: 'Asigna límite de crédito por cliente. ',
    list3: 'Obtén reportes de cuentas por cobrar.'
  },
  {
    image: {
      name: 'Picture of the author',
      url: '/img/benefits/report.svg'
    },
    title: 'Reportes personalizados',
    description: 'Tenemos más de 15 diferentes reportes personalizables. Crea reportes detallados de compras, ventas, por proveedor, etc. Exporta los reportes a Excel o PDF. ',
    list1: 'Tenemos más de 15 diferentes reportes personalizables.',
    list2: 'Crea reportes detallados de compras, ventas, por proveedor, etc.',
    list3: 'Exporta los reportes a Excel o PDF.'
  },
  {
    image: {
      name: 'Picture of the author',
      url: '/img/benefits/Mobile_app.svg'
    },
    title: 'Aplicación móvil',
    description: 'Movilidad total&ldquo; Toda la administración de tu negocio siempre contigo. Compra, vende, cobra, paga, cambia precios, etc. en cualquier lugar. Tenemos la app más completa para el control de reciclaje.',
    list1: '"Movilidad total" Toda la administración de tu negocio siempre contigo. ',
    list2: 'Compra, vende, cobra, paga, cambia precios, etc. ',
    list3: ' en cualquier lugar. Tenemos la app más completa para el control de reciclaje.'
  },
  {
    image: {
      name: 'Picture of the author',
      url: '/img/benefits/meeting.svg'
    },
    title: 'Control de usuarios',
    description: 'Agrega cuantos usuarios necesites (costo adicional). Asigna permisos y accesos especiales a cada uno de tus empleados. Privacidad de información según el usuario registrado',
    list1: 'Agrega cuantos usuarios necesites (costo adicional).',
    list2: 'Asigna permisos y accesos especiales a cada uno de tus empleados.',
    list3: 'Privacidad de información según el usuario registrado.'
  },
  {
    image: {
      name: 'Picture of the author',
      url: '/img/benefits/book.svg'
    },
    title: 'Cuentas por cobrar',
    description: 'Estados de cuentas detallados por cliente. Información detallada de cobros pendientes. Realiza abonos parciales o totales a boletas pendientes.',
    list1: 'Estados de cuentas detallados por cliente.',
    list2: 'Información detallada de cobros pendientes.',
    list3: 'Realiza abonos parciales o totales a boletas pendientes.'
  },
  {
    image: {
      name: 'Picture of the author',
      url: '/img/benefits/billing.svg'
    },
    title: 'Facturción',
    description: 'Crea, timbra y envía facturas con CDFI 3.3. Gestiona toda tu facturación desde un mismo lugar. Genera complementos de pago.',
    list1: 'Crea, timbra y envía facturas con CDFI 3.3.',
    list2: 'Gestiona toda tu facturación desde un mismo lugar. ',
    list3: ' Genera complementos de pago.'
  },
  {
    image: {
      name: 'Picture of the author',
      url: '/img/benefits/safe_box.svg'
    },
    title: 'Control de caja chica',
    description: 'Registra cada entrada y/o salida de efectivo con justificación por usuario. Realiza cortes de turnos por cada usuario. Recibe el corte directamente a tu celular.',
    list1: 'Registra cada entrada y/o salida de efectivo con justificación por usuario. ',
    list2: 'Realiza cortes de turnos por cada usuario. ',
    list3: ' Recibe el corte directamente a tu celular.'
  },
  {
    image: {
      name: 'Picture of the author',
      url: '/img/benefits/branch_control.svg'
    },
    title: 'Control de sucursales',
    description: 'Centraliza el control de todas tus sucursales. Controla tus diferentes sucursales de manera independiente.',
    list1: 'Centraliza el control de todas tus sucursales. ',
    list2: ' Controla tus diferentes sucursales de manera independiente.',
    list3: ''
  },
  {
    image: {
      name: 'Picture of the author',
      url: '/img/benefits/invoice.svg'
    },
    title: 'Impresión de tickets',
    description: 'Entrega comprobantes de compra a tus proveedores. Ticket con información detallada de compra o venta (opción de reimpresión). Edita el ticket con tu información y logotipo.',
    list1: 'Entrega comprobantes de compra a tus proveedores.',
    list2: ' Ticket con información detallada de compra o venta (opción de reimpresión).',
    list3: ' Edita el ticket con tu información y logotipo.'
  }

]
